import { render } from "./ManageMailsContent.vue?vue&type=template&id=3be9b552"
import script from "./ManageMailsContent.vue?vue&type=script&lang=js"
export * from "./ManageMailsContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__